import React, { FC } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@hooks/redux-custom';
import { setToastSettings } from '@store/slices/notification';

export type ToastSettings = {
  message?: string;
  show: boolean;
  type?: 'success' | 'error';
};

export const Toast: FC = () => {
  const { message, show, type } = useAppSelector((state) => state.notification.value.toastSettings);

  const dispatch = useAppDispatch();

  const handleAlertClose = () =>
    dispatch(
      setToastSettings({
        message: undefined,
        type: undefined,
        show: false,
      }),
    );

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={3000}
      onClose={handleAlertClose}
      open={show}
      data-testid={`toast-${type}`}
    >
      <Alert severity={type}>{message}</Alert>
    </Snackbar>
  );
};
